"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeID = void 0;
exports.ExchangeID = {
    standardName(id) {
        switch (id) {
            case this.BIBOX: {
                return "Bibox";
            }
            case this.BIGONE: {
                return "BigONE";
            }
            case this.BITCOINCOID: {
                return "Bitcoin.co.id";
            }
            case this.BINANCE: {
                return "Binance";
            }
            case this.BITFINEX: {
                return "Bitfinex";
            }
            case this.BITFOREX: {
                return "BitForex";
            }
            case this.BITHUMB: {
                return "Bithumb";
            }
            case this.BITMAX: {
                return "BitMax";
            }
            case this.BITTREX: {
                return "Bittrex";
            }
            case this.BITZ: {
                return "Bit-Z";
            }
            case this.COINEX: {
                return "CoinEx";
            }
            case this.COINPARK: {
                return "CoinPark";
            }
            case this.COINTIGER:
                return "CoinTiger";
            case this.CRYPTOPIA: {
                return "Cryptopia";
            }
            case this.FCOIN: {
                return "FCoin";
            }
            case this.GATE_IO: {
                return "Gate.io";
            }
            case this.GDAX: {
                return "GDAX";
            }
            case this.HADAX: {
                return "HADAX";
            }
            case this.HITBTC: {
                return "HitBTC";
            }
            case this.HUOBI: {
                return "Huobi Global";
            }
            case this.INDODAX: {
                return "Indodax";
            }
            case this.KUCOIN: {
                return "KuCoin";
            }
            case this.OKEX: {
                return "OKEx";
            }
            case this.POLONIEX: {
                return "Poloniex";
            }
            case this.PIONEX:
            case this.PIONEXV2:
            case this.PIONEX_SWAP: {
                return "Pionex";
            }
            case this.SHUBAO: {
                return "ShuBao";
            }
            case this.UEX: {
                return "UEX";
            }
            case this.UPBIT: {
                return "UPbit";
            }
            case this.ZB: {
                return "ZB";
            }
            case this.BITOPRO: {
                return "BitoPro";
            }
            case this.CEO: {
                return "CEO Global";
            }
            case this.LIQUID: {
                return "Liquid";
            }
            case this.LBANK: {
                return "LBank";
            }
            case this.COINBASEPRO: {
                return "Coinbase Pro";
            }
            case this.HYDAX: {
                return "Hydax";
            }
            case this.MXC:
                return "MEXC";
            case this.HBTC:
                return "HBTC";
            case this.BYBIT:
                return "Bybit";
            case this.FTX:
                return "FTX";
            case this.PROBIT:
                return "ProBit";
            case this.BITGET:
                return "Bitget";
            case this.FOBLGATE:
                return "FOBLGATE";
        }
        return id;
    },
    ACX: "acx",
    ALLCOIN: "allcoin",
    ANX: "anx.pro",
    ANYBITS: "anybits",
    BIBOX: "bibox",
    BIGONE: "big.one",
    BINANCE: "binance",
    BIT2C: "bit2c",
    BITBANK: "bitbank.cc",
    BITBAY: "bitbay",
    BITCOINCOID: "bitcoin.co.id",
    BITFINEX: "bitfinex",
    BITFLYER: "bitflyer",
    BITFOREX: "bitforex",
    BITHUMB: "bithumb",
    BITLISH: "bitlish",
    BITMARKET: "bitmarket",
    BITMAX: "bitmax",
    BITMEX: "bitmex",
    BITSANE: "bitsane",
    BITSO: "bitso",
    BITSTAMP: "bitstamp",
    BITTREX: "bittrex",
    BITZ: "bit-z",
    BL3P: "bl3p.eu",
    BLEUTRADE: "bleutrade",
    BRAZILIEX: "braziliex",
    BTCBOX: "btcbox",
    BTCMARKETS: "btcmarkets",
    BTCTRADEIM: "btctrade.im",
    BTCTRADEUA: "btctradeua",
    BTCTURK: "btcturk",
    BTCX: "btcx",
    BXINTH: "bx.in.th",
    CCEX: "c-cex",
    CEX_IO: "cex.io",
    CHILEBIT: "chilebit",
    COBINHOOD: "cobinhood",
    COINBASE: "coinbase",
    COINBENE: "coinbene",
    COINBIG: "coinbig",
    COINCHECK: "coincheck",
    COINEGG: "coinegg",
    COINEX: "coinex",
    COINBASEPRO: "coinbase.pro",
    COINEXCHANGE: "coinexchange",
    COINFALCON: "coinfalcon",
    COINFLOOR: "coinfloor",
    COINGI: "coingi",
    COINMATE: "coinmate",
    COINNEST: "coinnest",
    COINONE: "coinone",
    COINPARK: "coinpark.cc",
    COINSPOT: "coinspot",
    COINTIGER: "cointiger",
    COOLCOIN: "coolcoin",
    CRYPTON: "cryptonex",
    CRYPTOPIA: "cryptopia",
    DERIBIT: "deribit",
    DSX: "dsx.uk",
    ETHFINEX: "ethfinex",
    EXMO: "exmo",
    EXX: "exx",
    FCOIN: "fcoin",
    FLOWBTC: "flowbtc",
    FOXBIT: "foxbit",
    FYBSE: "fybse",
    FYBSG: "fybsg",
    GATECOIN: "gatecoin",
    GATE_IO: "gate.io",
    GDAX: "gdax",
    GEMINI: "gemini",
    GETBTC: "getbtc",
    HADAX: "hadax",
    HITBTC: "hitbtc",
    HUOBI: "huobi.pro",
    ICE3X: "ice3x",
    INDEPENDENTRESERVE: "independentr",
    INDODAX: "indodax",
    ITBIT: "itbit",
    KRAKEN: "kraken",
    KUCOIN: "kucoin",
    KUNA: "kuna",
    LAKEBTC: "lakebtc",
    LBANK: "lbank",
    LIQUI: "liqui",
    LIVECOIN: "livecoin",
    LUNO: "luno",
    LYKKE: "lykke",
    MERCADOBITCOIN: "mercadobitcoin",
    MIXCOINS: "mixcoins",
    NEGOCIECOINS: "negociecoins",
    NOVA: "novaexchange",
    OCX: "ocx",
    OKEX: "okex",
    PAYMIUM: "paymium",
    PIONEX: "pionex",
    POLONIEX: "poloniex",
    QRYPTOS: "qryptos",
    QUADRIGACX: "quadrigacx",
    QUOINE: "quoine",
    SOUTHXCHANGE: "southxchange",
    SURBITCOIN: "surbitcoin",
    THEROCK: "therocktrading",
    TIDEBIT: "tidebit",
    TIDEX: "tidex",
    TOP_ONE: "top.one",
    UEX: "uex",
    UPBIT: "upbit",
    URDUBIT: "urdubit",
    VAULTORO: "vaultoro",
    VBTC: "vbtc",
    VIRWOX: "virwox",
    WEX: "wex.nz",
    XBTCE: "xbtce",
    YOBIT: "yobit",
    ZAIF: "zaif",
    ZB: "zb",
    _1BROKER: "_1broker",
    _1BTCXE: "_1btcxe",
    SHUBAO: "shubao",
    BITOPRO: "bitopro",
    CEO: "ceo",
    LIQUID: "liquid",
    PIONEXV2: "pionex.v2",
    BITBNS: "bitbns",
    HYDAX: "hydax",
    MXC: "mxc",
    HBTC: "hbtc",
    BYBIT: "bybit",
    FTX: "ftx",
    PROBIT: "probit",
    PIONEX_SWAP: "pionex.binance.swap",
    BITGET: "bitget",
    FOBLGATE: "foblgate",
};
